import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { GastrointestinalQuestionnaireItem } from './questionnaire'

export const GASTROINTESTINAL_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [GastrointestinalQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_GI_ASSESSMENT]:
    QuestionnaireAnswerType.STRING,
  [GastrointestinalQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_BM_DATE]:
    QuestionnaireAnswerType.DATE,
  [GastrointestinalQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_GU_ASSESSMENT]:
    QuestionnaireAnswerType.STRING,
  [GastrointestinalQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_CATHETER]:
    QuestionnaireAnswerType.STRING,
  [GastrointestinalQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_CATHETER_TYPE]:
    QuestionnaireAnswerType.STRING,
  [GastrointestinalQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_FEEDING_TUBE]:
    QuestionnaireAnswerType.STRING,
  [GastrointestinalQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_FEEDING_TUBE_AMOUNT]:
    QuestionnaireAnswerType.INTEGER,
  [GastrointestinalQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_FEEDING_TOTAL_NUMBER]:
    QuestionnaireAnswerType.INTEGER,
  [GastrointestinalQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_FEEDING_TUBE_DURATION]:
    QuestionnaireAnswerType.STRING,
  [GastrointestinalQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_FEEDING_TUBE_TYPE]:
    QuestionnaireAnswerType.STRING,
  [GastrointestinalQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_FEEDING_TUBE_SITE]:
    QuestionnaireAnswerType.STRING,
  [GastrointestinalQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_FEEDING_TUBE_SIZE]:
    QuestionnaireAnswerType.STRING,
  [GastrointestinalQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_FEEDING_TUBE_NOTES]:
    QuestionnaireAnswerType.STRING,
  [GastrointestinalQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_NUTRITION_WNL]:
    QuestionnaireAnswerType.STRING,
  [GastrointestinalQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_NUTRITIONAL_FACTORS]:
    QuestionnaireAnswerType.STRING,
  [GastrointestinalQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_DIET_REQUIREMENTS]:
    QuestionnaireAnswerType.STRING,
  [GastrointestinalQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_NUTRITION_NOTES]:
    QuestionnaireAnswerType.STRING,
  [GastrointestinalQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_NUTRITIONAL_SCREENING]:
    QuestionnaireAnswerType.STRING,
  [GastrointestinalQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_GASTROINTESTINAL_HISTORY_NOTES]:
    QuestionnaireAnswerType.STRING,
  [GastrointestinalQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_SYSTEM_SUMMARY]:
    QuestionnaireAnswerType.STRING
}
